module.exports = __webpack_public_path__ + "ca5fd9c5628a8f5d344fd3f4e46ddeba.pdf";